import styled from "styled-components";

export const VtripNotice = styled("div")(({ theme }) => ({
  ...theme.paddings(8, 12),
  ...theme.margins(10, 10, 0),
  backgroundColor: "#fff7e6",
  border: "1px solid #ffd591",
  borderRadius: 4,
  color: "#7a4b00",
  fontSize: 12,
  lineHeight: 1.4,
}));

export const Wrapper = styled("div")(({ theme }) => ({
  width: 800,
  backgroundColor: "transparent",

  [theme.upDown("lg", "xl")]: {
    width: 590,
  },

  [theme.upDown("md", "lg")]: {
    width: 680,
  },

  [theme.upDown("sm", "md")]: {
    width: 550,
  },

  [theme.down("sm")]: {
    width: "100%",
  },
}));
